import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7c388d9d")

_pushScopeId("data-v-7c388d9d")
const _hoisted_1 = {
  key: 1,
  class: "overflow-y-auto h-screen"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Ubah Konfigurasi Biaya ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "flex flex-row h-screen py-6" }
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_8 = { class: "flex flex-row w-3/4" }
const _hoisted_9 = { class: "py-3 w-full mr-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Konfigurasi Biaya ", -1)
const _hoisted_11 = { class: "flex flex-row w-3/4" }
const _hoisted_12 = { class: "py-3 w-full mr-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Deskripsi "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, "(optional)")
], -1)
const _hoisted_14 = { class: "inline-block relative w-full" }
const _hoisted_15 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-4 text-gray-700" }
const _hoisted_16 = { class: "text-12px text-gray-lp-500" }
const _hoisted_17 = { class: "flex flex-row w-3/4" }
const _hoisted_18 = { class: "py-3 w-2/3 mr-4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Tipe Tambahan Biaya ", -1)
const _hoisted_20 = { class: "flex flex-row w-3/4" }
const _hoisted_21 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_22 = { class: "font-semibold text-black-lp-300 pb-2 flex flex-row space-x-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "whitespace-no-wrap" }, "Nilai Tambah Biaya", -1)
const _hoisted_24 = { class: "font-normal text-gray-lp-500 whitespace-no-wrap" }
const _hoisted_25 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " % ", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 text-12px whitespace-no-wrap" }, " Woodpacking = Base Rate x Tambahan Biaya ", -1)
const _hoisted_28 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " IDR ", -1)
const _hoisted_30 = { class: "w-3/4" }
const _hoisted_31 = { class: "mt-1.5" }
const _hoisted_32 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Konfigurasi Biaya "),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Anda bisa mengaktifkan status ini kapan saja ")
], -1)
const _hoisted_34 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_36 = { class: "ml-4" }
const _hoisted_37 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_38 = { class: "py-3" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Konfigurasi Biaya ", -1)
const _hoisted_40 = { class: "my-1 text-black-lp-300" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "py-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_44 = { class: "my-1 text-black-lp-300" }
const _hoisted_45 = { class: "text-gray-lp-500" }
const _hoisted_46 = { class: "py-3" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diperbarui", -1)
const _hoisted_48 = { class: "my-1 text-black-lp-300" }
const _hoisted_49 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_button_fill, {
                disabled: !_ctx.isFormValid,
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["disabled", "onClick"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("input", {
                    type: "text",
                    placeholder: _ctx.dataDetail.name,
                    class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                    disabled: _ctx.isDisabled
                  }, null, 10, ["placeholder", "disabled"])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _withDirectives(_createVNode("textarea", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataDetail.description = $event)),
                      onInput: _cache[3] || (_cache[3] = e => _ctx.inputDescription(e.target.value)),
                      cols: "70",
                      rows: "7",
                      maxlength: "1000",
                      placeholder: "Tulis deskripsi produk disini",
                      class: 
                  `focus:border-red-lp-100
            py-1.5 xxl:py-3 px-4 rounded border focus:outline-none focus:shadow my-1
            text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
                
                    }, null, 34), [
                      [_vModelText, _ctx.dataDetail.description]
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("p", _hoisted_16, _toDisplayString(_ctx.dataDetail.description.length) + "/1000 ", 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Select, {
                    dataSelect: 
                _ctx.typeName === 'percentage' ? _ctx.typeData : _ctx.typeDataVolume
              ,
                    onOpenSelect: _ctx.onOpenTypeSelect,
                    onCloseSelect: _ctx.onCloseTypeSelect,
                    onChooseSelect: _ctx.onSelectType,
                    value: _ctx.typeName,
                    isOpenMenu: _ctx.typeSelect,
                    class: "w-full z-10"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createVNode("span", _hoisted_24, "(Per Berat Volume)", 512), [
                      [_vShow, _ctx.typeName === 'Per Berat Volume']
                    ])
                  ]),
                  _withDirectives(_createVNode("div", null, [
                    _createVNode("div", _hoisted_25, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataDetail.additionalCost = $event)),
                        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputFormatRupiah(_ctx.minPrice))),
                        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                      }, null, 544), [
                        [_vModelText, _ctx.dataDetail.additionalCost]
                      ]),
                      _hoisted_26
                    ]),
                    _hoisted_27
                  ], 512), [
                    [_vShow, _ctx.typeValue.toLowerCase() === 'percentage']
                  ]),
                  _withDirectives(_createVNode("div", null, [
                    _createVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataDetail.additionalCost = $event)),
                        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInputFormatRupiah(_ctx.minPrice))),
                        onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                      }, null, 544), [
                        [_vModelText, _ctx.dataDetail.additionalCost]
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.typeValue.toLowerCase() === 'volume-weight' || _ctx.typeValue.toLowerCase() === 'dimension']
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode(_component_DataWrapper, {
                  class: "col-span-2",
                  label: "Kota Penyedia Woodpacking"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_31, [
                      _createVNode(_component_MultipleSelectSearch, {
                        "option-name": "name",
                        onFocus: _ctx.filterCity,
                        onFilter: _ctx.filterCity,
                        options: _ctx.listCity,
                        modelValue: _ctx.searchCity,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchCity = $event)),
                        keyName: "city_name",
                        keyValue: "city_code",
                        placeholder: "Ketik atau pilih kota",
                        isLoading: _ctx.isLoadingCity,
                        showReset: "",
                        "able-to-delete-in-modal": "",
                        customDisplayAll: "Semua"
                      }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", {
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onOpenRoute && _ctx.onOpenRoute(...args))),
                    class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                  }, [
                    _hoisted_35
                  ], 2),
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                    }, _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 3)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("div", _hoisted_44, _toDisplayString(_ctx.createdAt), 1),
                _createVNode("div", _hoisted_45, _toDisplayString(_ctx.createdBy), 1)
              ]),
              _createVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode("div", _hoisted_48, _toDisplayString(_ctx.updateAt), 1),
                _createVNode("div", _hoisted_49, _toDisplayString(_ctx.updateBy), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: 
      _ctx.isRoute
        ? 'Non-aktifkan Configurable Price'
        : 'Aktifkan Configurable Price'
    ,
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
      image: "warning",
      textSuccess: _ctx.isRoute ? 'Non-aktifkan' : 'Aktifkan',
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "textSuccess"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: `Detail Configurable Price "${_ctx.dataDetail.name}" berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Configurable Price",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Configurable Price “${_ctx.dataDetail.name}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
})